import { useState, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom'
import { Toast } from 'react-vant'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import CustomButton from '@/components/CustomButton'
import CustomTextInput from '@/components/CustomTextInput'
import FixedBottom from '@/components/FixedBottom'
import { APIWeb } from '@/api'

export default function RedemptionCode() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const [searchParams] = useSearchParams()

    // 兑换码
    const [code, setCode] = useState('')

    // 从 URL 获取参数
    const cardType = searchParams.get('type') || 'electronic'
    const productId = searchParams.get('productId') || ''

    // 从 location.state 获取产品数据
    const product = (location.state as { product?: ModelsCardProduct })?.product

    const [loading, setLoading] = useState(false)

    const handleRedeem = useCallback(async () => {
        if (!code.trim()) {
            Toast.info({
                message: t('请输入兑换码'),
                position: 'middle'
            })
            return
        }

        setLoading(true)
        try {
            const res = await APIWeb.verifyCardRedemptionCode({ activation_code: code.trim() })
            if (res.data) {
                navigate(`/card-v2/confirm-payment?type=${cardType}&productId=${productId}&activationCode=${encodeURIComponent(code.trim())}`, {
                    state: { product }
                })
            } else {
                Toast.fail({
                    message: t('兑换码无效'),
                    position: 'middle'
                })
            }
        } catch {
            Toast.fail({
                message: t('兑换码验证失败'),
                position: 'middle'
            })
        } finally {
            setLoading(false)
        }
    }, [code, cardType, productId, product, navigate, t])

    return (
        <PageLayout>
            <Header
                leftChildren={<Back />}
                centerChildren={<span className="text-base font-medium">{t('使用兑换码')}</span>}
            />

            <div className="px-5 pt-6">
                {/* 兑换码输入 */}
                <div className="mb-6">
                    <div className="text-sm text-[#4E5969] mb-2">{t('兑换码')}</div>
                    <CustomTextInput
                        value={code}
                        onChangeText={setCode}
                        placeholder={t('输入兑换码')}
                    />
                </div>

                {/* 温馨提示 */}
                <div className="text-sm text-[#4E5969]">
                    <div className="text-[#667085] font-medium mb-2">{t('温馨提示')}：</div>
                    <div className="text-xs text-[#667085] leading-6">
                        {t('输入兑换码后，完成首充即可成功兑换卡片，充值金额可全额用于后续消费，无额外限制。')}
                    </div>
                </div>
            </div>

            {/* 固定在底部的兑换按钮 */}
            <FixedBottom>
                <CustomButton 
                    onClick={handleRedeem}
                    disabled={!code.trim() || loading}
                    loading={loading}
                >
                    {t('立即兑换')}
                </CustomButton>
            </FixedBottom>
        </PageLayout>
    )
}

